<template>
  <div class="admin-layout">
    <app-side-menu></app-side-menu>
    <div class="content-container">
      <app-toolbar></app-toolbar>
      <div class="router-container custom-scroll">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import AppSideMenu from '@/components/Layout/AppSideMenu.vue';
import AppToolbar from '@/components/Layout/AppToolbar.vue';
import { STORAGE } from '@/constants/storage.constants';
import Api from '@/services/api';

export default {
  name: 'admin-layout',
  components: {
    AppSideMenu,
    AppToolbar,
  },
  beforeMount() {
    Api.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${localStorage.getItem(STORAGE.AUTH_TOKEN)}`;
  },
};
</script>

<style lang="scss" scoped>
.admin-layout {
  display: flex;
  height: 100vh;

  .app-side-menu {
    position: relative;
    z-index: 2;
  }

  .content-container {
    width: calc(100vw - var(--sidemenu-width));
    padding-top: var(--toolbar-height);

    .app-toolbar {
      position: fixed;
      top: 0;
      right: 0;
      left: var(--sidemenu-width);
      z-index: 2;
    }

    .router-container {
      position: relative;
      z-index: 1;
      height: 100%;
      padding: 32px;
      background: var(--background);
      overflow-y: scroll;
    }
  }
}
</style>
